import {adapt_pedido_cotizacion} from "../Adaptadores/adapt_pedido_cotizacion";
import axios from "axios";

export const obtenerCotizaciones = async (pedido) => {

    let formatoPedido = adapt_pedido_cotizacion(pedido);
  //  console.log(formatoPedido);

    let data = JSON.stringify(formatoPedido);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
      // url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/e54ea91d-a226-4852-affb-0a047055716a', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/e54ea91d-a226-4852-affb-0a047055716a',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return axios.request(config)


}